import PodcastPage from './PodcastPage';

export default PodcastPage;
